import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon, InputUI, SearchIcon } from "@parkschannel/ui";
import React, { useEffect, useRef, useState } from "react";
import { useDebounce } from "usehooks-ts";
import classNames from "classnames";
export const DebouncedSearch = (param)=>{
    let { value , onChange , placeholder  } = param;
    const wrapperRef = useRef(null);
    const [search, setSearch] = useState(value);
    const [focused, setFocused] = useState(false);
    const debounced = useDebounce(search);
    const onFocus = ()=>{
        setFocused(true);
    };
    const onBlur = ()=>{
        setFocused(false);
    };
    const onClear = ()=>{
        setSearch("");
    };
    useEffect(()=>{
        if (debounced === value) return;
        onChange(debounced || "");
    }, [
        debounced
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        ref: wrapperRef,
        className: "relative w-full max-w-[740px]",
        children: [
            /*#__PURE__*/ _jsx(SearchIcon, {
                className: classNames("absolute top-1/2 left-2 -translate-y-1/2", {
                    "text-neutral-200": !focused,
                    "text-neutral-600": focused
                })
            }),
            /*#__PURE__*/ _jsx(InputUI.Text, {
                placeholder: placeholder,
                onChange: (e)=>setSearch(e.target.value),
                value: search,
                className: "pl-10 pr-8",
                onFocus: onFocus,
                onBlur: onBlur
            }),
            /*#__PURE__*/ _jsx("button", {
                className: classNames("w-6 h-6 flex justify-center items-center absolute top-1/2 -translate-y-1/2 right-2 hover:opacity-100", {
                    "opacity-100": focused,
                    "opacity-0": !focused
                }),
                type: "button",
                onClick: onClear,
                children: /*#__PURE__*/ _jsx(CloseIcon, {
                    className: "w-3 h-3 text-neutral-400 stroke-[1px]",
                    strokeWidth: 1
                })
            })
        ]
    });
};
